import React, { useCallback } from 'react';
import Card from 'components/inputs/Card';
import { Formik, Form } from 'formik';
import { Row, Col } from 'react-bootstrap';
import Button from 'components/inputs/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { UNLOCK_CONNECTOR } from 'actions/chargerOcpp';
import { toast } from 'react-toastify';
import * as _ from 'lodash';
import Select from 'components/inputs/Select';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { GET_STATION_CHARGER_OPERATIONS, MANAGE_STATION_CHARGER_OPERATIONS } from 'components/common/constant';

const UnlockConnectorForm = () => {
  const { chargerId } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const chargerDetailData = useSelector((state) => state.charger.chargerDetails);
  const rolePermissionData = useSelector((state) => state.manageRole.manageRoles);

  const initialValues = {
    connectorId: '',
  };

  const handleUnlockConnector = useCallback((data, resetForm) => {
    dispatch({
      type: UNLOCK_CONNECTOR.REQUEST,
      payload: { data },
      cb: (res) => {
        if (res) {
          if (_.get(res, 'status') === 200) {
            toast.success('Connector unlocked successfully');
            resetForm();
          }
        }
      },
    });
  }, []);

  const getStationChargerOperations =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === GET_STATION_CHARGER_OPERATIONS),
      (data) => data.name
    );

  const UnlockConnectorSchema = Yup.object().shape({
    connectorId: Yup.number().required(t('unlockConnectorForm.connectorId')),
  });

  const manageStationChargerOperations =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === MANAGE_STATION_CHARGER_OPERATIONS),
      (data) => data.name
    );

  return (
    <React.Fragment>
      <div className="serverOperation-title-name">{t('unlockConnectorForm.formTitle')}</div>
      <div className="serverOperation-content-wrapper">
        <Card className="serverOperation-form-main">
          <div className="serverOperation-form__block">
            <Formik
              initialValues={initialValues}
              validationSchema={UnlockConnectorSchema}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                const formData = {
                  id: chargerId,
                  ...values,
                };
                handleUnlockConnector(formData, resetForm);
                setSubmitting(false);
              }}
            >
              {({ values, errors, touched, handleSubmit, setFieldValue, isSubmitting }) => (
                <Form onSubmit={handleSubmit}>
                  <div className="serverOperation-form__inner">
                    <Row>
                      <Col>
                        <Select
                          isRequired
                          label={t('unlockConnectorForm.connectorName')}
                          placeholder={t('placeHolder.selectConnector')}
                          options={_.map(_.get(chargerDetailData, 'plugs', []), (item) => {
                            return { label: `${item.name} - ${item.connector_id}`, value: item.connector_id };
                          })}
                          name="connectorId"
                          value={values.connectorId}
                          onChange={(val) => setFieldValue(`connectorId`, val)}
                          error={errors.connectorId && touched.connectorId ? errors.connectorId : null}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="serverOperation-save--btn--block">
                    {!_.isEmpty(manageStationChargerOperations) ||
                    (!_.isEmpty(getStationChargerOperations) && !_.isEmpty(manageStationChargerOperations)) ? (
                      <Button type="submit" className="serverOperation-save-btn save--btn" disabled={isSubmitting}>
                        {t('unlockConnectorForm.button')}
                      </Button>
                    ) : (
                      <Button className="serverOperation-save-btn save--btn">{t('unlockConnectorForm.button')}</Button>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
export default UnlockConnectorForm;
